import { AuthContext } from "@@components";
import { useCallback, useContext } from "react";
import { ApiException } from "../../api/api";

const HTTP_UNAUTHORIZED = 401;

/**
 * Custom hook to handle API errors, particularly 401 Unauthorized responses
 */
export function useApiErrorHandler() {
  const auth = useContext(AuthContext);

  const handleApiError = useCallback(
    async (error: any) => {
      // Check if it's an ApiException with 401 status
      if (error instanceof ApiException && error.status === HTTP_UNAUTHORIZED) {
        console.warn(
          "API call failed with 401 Unauthorized. Redirecting to sign in."
        );

        try {
          const currentPath = window.location.pathname + window.location.search;
          await auth.authService.signIn(currentPath);
        } catch (signInError) {
          console.error("Error during sign-in redirect:", signInError);
        }

        return true; // Indicates we handled the error
      }

      // Check if it's a Response object with 401 status
      if (error?.status === HTTP_UNAUTHORIZED) {
        console.warn(
          "API call failed with 401 Unauthorized. Redirecting to sign in."
        );

        try {
          const currentPath = window.location.pathname + window.location.search;
          await auth.authService.signIn(currentPath);
        } catch (signInError) {
          console.error("Error during sign-in redirect:", signInError);
        }

        return true; // Indicates we handled the error
      }

      return false; // Did not handle the error
    },
    [auth]
  );
  return handleApiError;
}

export default useApiErrorHandler;
